<template>
  <div>
    <Drawer title="编辑" width="600" :value="showEditUser" :mask-closable="true" @on-close="cancelEdit">
      <Form ref="userForm" @keydown.native.enter.prevent="doSubmit" :label-width="80">
        <FormItem label="手机号" prop="mobile">
          <Input v-model="userForm.mobile" placeholder="请输入手机号"></Input>
        </FormItem>
        <FormItem label="真实姓名" prop="real_name">
          <Input v-model="userForm.real_name" placeholder="请填写真实姓名"></Input>
        </FormItem>
        <FormItem label="密码" prop="pwd">
          <Input v-model="userForm.pwd" placeholder="请填写密码(不修改则不填，新增必填)"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <i-switch v-model="userForm.status" size="large" :true-value="1" :false-value="-1" false-color="red">
            <span slot="open">正常</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
        <div class="drawer-footer">
          <Button style="margin-right: 8px" @click="cancelEdit">取消</Button>
          <Button type="primary" @click="doSubmit">确定</Button>
        </div>
      </Form>
    </Drawer>
  </div>
</template>

<script>
  export default {
    name: "user-edit",
    props:{
      showEditUser:{
        type:Boolean,
        default: false
      },

      userId:{
        type:Number,
        default: 0
      }
    },
    data(){
      return {
        userForm:{
          uid:0,
          account:'',
          mobile:'',
          real_name:'',
          pwd:'',
          status: 1,
        }
      }
    },
    methods:{
      async getUserInfo(){
        let res = await this.$commonFun.postProxy('admin/system/admin_user/getInfoById',{uid:this.userId})
        this.userForm = {
          uid:res.data.uid,
          mobile: res.data.mobile,
          real_name: res.data.name,
          pwd: '',
          status:  parseInt(res.data.status)
        }
      },
      cancelEdit(){
         this.$emit('cancel-edit')
      },
      async doSubmit(){
        let _self = this
        let res = await this.$commonFun.postProxy('admin/my_company/editAdminUsers',this.userForm)
        //编辑成功刷新父页面
        this.$commonFun.dealApiResult(res,()=>{
          _self.$commonFun.successTip('操作成功!',function () {
            _self.$emit('edit-success')
          })
        })
      }
    },
    mounted() {
      if (this.userId > 0){
        this.getUserInfo()
      }
    },
  }
</script>

<style scoped lang="less">
  .drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
  }

</style>